import { createBrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ServiceCatalog from "./pages/ServiceCatalog";
import ServiceDetail from "./pages/ServiceDetail";
import Builds from "./pages/Builds";
import Deployments from "./pages/Deployments";
import Observability from "./pages/Observability";
import Infrastructure from "./pages/Infrastructure";
import Tenants from "./pages/Tenants";
import Costs from "./pages/Costs";
import TenantProducts from "./pages/TenantProducts";
import TenantProductServices from "./pages/TenantProductServices";
import ManagementDashboard from "./pages/ManagementDashboard";
import CollectorStatus from "./pages/CollectorStatus";
import Environments from "./pages/Environments";
import AdminUsers from "./pages/AdminUsers";
import AdminAuditLogs from "./pages/AdminAuditLogs";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import AuthGate from "./components/AuthGate";

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/change-password", element: <ChangePassword /> },
  {
    path: "/",
    element: (
      <AuthGate>
        <Layout />
      </AuthGate>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: "services", element: <ServiceCatalog /> },
      { path: "services/:slug", element: <ServiceDetail /> },
      { path: "builds", element: <Builds /> },
      { path: "deployments", element: <Deployments /> },
      { path: "observability", element: <Observability /> },
      { path: "infrastructure", element: <Infrastructure /> },
      { path: "costs", element: <Costs /> },
      // Kept so existing links and bookmarks still land somewhere: same
      // shell, unit tab preselected.
      { path: "unit-costs", element: <Costs defaultTab="unit" /> },
      { path: "tenants", element: <Tenants /> },
      { path: "tenants/:tenantId", element: <TenantProducts /> },
      { path: "tenants/:tenantId/products/:product", element: <TenantProductServices /> },
      { path: "management", element: <ManagementDashboard /> },
      { path: "environments", element: <Environments /> },
      { path: "collectors", element: <CollectorStatus /> },
      { path: "admin/users", element: <AdminUsers /> },
      { path: "admin/audit-logs", element: <AdminAuditLogs /> },
    ],
  },
]);
